import { render, staticRenderFns } from "./SumSection.vue?vue&type=template&id=1c523efb&"
import script from "./SumSection.vue?vue&type=script&lang=js&"
export * from "./SumSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports